import React from "react";
const AriaText = props => {
    return (React.createElement("span", { id: props.id, className: "m-invisible" }, props.children));
};
export default AriaText;
//# sourceMappingURL=AriaText.js.map